import React, { ReactElement } from 'react';
import { CardHeader } from '@europrocurement/flexy-components';
import { Box, Typography } from '@mui/material';

export type AttachmentDocumentsHeadingProps = {
    totalCount: number;
    titleDetails?: string;
    additionalAction?: ReactElement;
};

const AttachmentDocumentsHeading: React.FunctionComponent<AttachmentDocumentsHeadingProps> =
    function ({ totalCount, titleDetails, additionalAction }) {
        return (
            <CardHeader
                title={`Documents joints${titleDetails ? ` - ${titleDetails}` : ''}`}
                titleSx={{
                    fontSize: '20px',
                    lineHeight: '28px',
                }}
                border={false}
                headerSx={{
                    paddingX: '32px',
                    paddingBottom: '1em',
                }}
                sx={{
                    paddingX: 0,
                }}
                childrenSx={{ paddingX: 0 }}
            >
                <Box>
                    {totalCount > 0 && (
                        <Typography
                            component="p"
                            variant="l2dbodyxs"
                            sx={{ color: 'text.gris50' }}
                        >
                            {totalCount} documents
                        </Typography>
                    )}
                    <Typography
                        component="p"
                        variant="l2dbodyxs"
                        sx={{ marginY: '8px', color: 'text.gris50' }}
                    >
                        Formats : .pdf .doc .jpg .xls - Poids maximum : 10Mo
                    </Typography>
                </Box>
                {additionalAction}
            </CardHeader>
        );
    };

export default AttachmentDocumentsHeading;
